/* eslint-disable react/jsx-pascal-case */
import {connect} from "react-redux";
import { setBackButtonShow } from "../../redux/actions/actions.js";
import Profile_Customize_ColorBtn from "./Profile_Customize_ColorBtn";
import Profile_Customize_FontSize from "./Profile_Customize_FontSize";
import Profile_Customize_BackgroundColor from "./Profile_Customize_BackgroundColor";
import React from "react";

class Profile_Customize extends React.Component {
    componentWillUnmount() {
        this.props.onSetBackButtonShow("hide");
    }
    render () {
        return(
            <div className="main_content_section_main main_content_section">
                <div className="profile_section">
                    <h1 className="profile_section_title">Customize your view</h1>
                    <p className="profile_section_paragraph">Manage your font size, color, and background. These settings affect all the Twitter accounts on this browser.</p>
                    <Profile_Customize_FontSize />
                    <Profile_Customize_ColorBtn />
                    <Profile_Customize_BackgroundColor />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        color_button: state.getColorButton.color_button,
        color_background: state.getColorBackground.color_background,
        font_size: state.getFontSize.font_size,
        user: state.getUser.user
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onSetBackButtonShow: (text) => dispatch(setBackButtonShow(text))
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Profile_Customize);